export default [
  {
    path: '/reportes',
    component: resolve => require(['./../index.vue'], resolve),
    children: [
      {
        path: '/reportes/libro-auxiliar-tercero',
        component: resolve => require(['../views/Auxiliary-book-contact/index.vue'], resolve),
        meta: {
          title: 'Libro Auxiliar por Tercero',
          permission: "libroAuxiliarTerceero"
        }
      },
      {
        path: '/reportes/reporte-ventas-compras',
        component: resolve => require(['../views/report-sales-purchases'], resolve),
        meta: {
          title: 'Informe de compras-ventas',
          permission: "Informe de compras-ventas"
        }
      },
      {
        path: '/reportes/report-commisions',
        component: resolve => require(['../views/Report-commisions/index.vue'], resolve),
        meta: {
          title: 'Informe de Recaudo',
          permission: "Informe de Recaudo"
        }
      },
      {
        path: '/reportes/report-bo/:seller_id?/:contact_id?',
        component: resolve => require(['../views/report-bo/index.vue'], resolve),
        meta: {
          title: 'Reporte BO',
          permission: "Reporte BO"
        }
      },
      {
        path: '/reportes/report-conciliation-balances',
        component: resolve => require(['../views/Conciliation-balances/index.vue'], resolve),
        meta: {
          title: 'Conciliación de Saldos WMS',
          permission: "Conciliacion Saldos WMS"
        }
      },
      {
        path: '/reportes/movimientos-cuenta-tercero',
        component: resolve => require(['../views/movements-account-contact/index.vue'], resolve),
        meta: {
          title: 'Movimientos cuenta tercero',
          permission: "Movimientos cuenta tercero"
        }
      },
      {
        path: '/reportes/libro-auxiliar',
        component: resolve => require(['../views/Auxiliary-book/index.vue'], resolve),
        meta: {
          title: 'Libro Auxiliar',
          permission: "libroAuxiliar"
        }
      },
        {
        path: '/reportes/libro-diario',
        component: resolve => require(['../views/accountin-detail/index.vue'], resolve),
        meta: {
          title: 'Libro Diario',
          permission: "Libro Diario"
        }
      },
      {
        path: '/reportes/comparativo-de-cuentas',
        component: resolve => require(['../views/account-comparison/index.vue'], resolve),
        meta: {
          title: 'comparativo de cuentas',
          permission: "Comparativo de Cuentas"
        }
      },
      {
        path: '/reportes/trial-balance',
        component: resolve => require(['../views/Balance-test/index.vue'], resolve),
        meta: {
          title: 'Balance de Prueba',
          permission: "balancePrueba"
        }
      },
      {
        path: '/reportes/trial-balance-contact',
        component: resolve => require(['../views/Balance-test-contact/index.vue'], resolve),
        meta: {
          title: 'Balance de Prueba por Tercero',
          permission: "balancePruebaTercero"
        }
      },
      {
        path: '/reportes/matriz-dinamica',
        component: resolve => require(['../views/dynamic-matrix/index.vue'], resolve),
        meta: {
          title: 'Analytrix Ventas Ultimo Semestre',
          permission: "Analytrix Ventas Ultimo Semestre"
        }
      }, {
        path: '/reportes/analisis-ventas',
        component: resolve => require(['../views/sales-analysis-report/index.vue'], resolve),
        meta: {
          title: 'Reporte de análisis de ventas',
          permission: "Analytrix Ventas Ultimo Semestre"
        }
      },
      {
        path: '/reportes/detalle-matriz-dinamica',
        component: resolve => require(['../views/sales-products/index.vue'], resolve),
        meta: {
          title: 'Detalle matriz dinámica',
          permission: "Analytrix Ventas Ultimo Semestre"
        }
      },
      {
        path: '/reportes/reporte-de-cartera/:contact_warehouse_id?',
        component: resolve => require(['../views/report-receivable/index.vue'], resolve),
        meta: {
          title: 'Reporte de cartera',
          permission: "Reporte de cartera"
        }
      },
      {
        path: '/reportes/proceso-de-pagos/',
        component: resolve => require(['../views/report-receivable/index_pp.vue'], resolve),
        meta: {
          title: 'Proceso de Pagos',
          permission: "Proceso de Pagos"
        }
      },
      {
        path: '/reportes/reporte-de-medios-magneticos',
        component: resolve => require(['../views/ReportMagneticMedia/index.vue'], resolve),
        meta: {
          title: 'Reporte Medios Magneticos',
          permission: "Reporte Medios Magneticos"
        }
      },
      {
        path: '/reportes/informe-conciliacion-bancaria',
        component: resolve => require(['../views/BankConciliation/index.vue'], resolve),
        meta: {
          title: 'Conciliacion Bancaria',
          permission: "Conciliacion Bancaria"
        }
      },
      {
        path: '/reportes/informe-de-consumos',
        component: resolve => require(['../views/report-consumption/index.vue'], resolve),
        meta: {
          title: 'Informe de Consumos',
          permission: "Informe de Consumos"
        }
      },
      {
        path: '/reportes/comisiones-venta-marca',
        component: resolve => require(['../views/report-commission-sale-brand/index.vue'], resolve),
        meta: {
          title: 'Comisiones x Venta x Marca',
          permission: "Comisiones x Venta x Marca"
        }
      },
      {
        path: '/reportes/reporte-inventario',
        component: resolve => require(['../views/report-ir/index.vue'], resolve),
        meta: {
          title: 'Reporte de Reposición de Inventario',
          permission: "REPORTE RI"
        }
      },
      {
        path: '/reportes/movimientos-proyecto',
        component: resolve => require(['../views/project-movements/index.vue'], resolve),
        meta: {
          title: 'Reporte de Movimientos por Proyecto',
          permission: "Movimientos por Proyecto"
        }
      },
      {
        path: '/reportes/historico-por-documento',
        component: resolve => require(['../views/report-historical-by-document/index.vue'], resolve),
        meta: {
          title: 'Historico Por Documento',
          permission: "Historico Por Documento"
        }
      },
      {
        path: '/reportes/saldos-contables',
        component: resolve => require(['../views/Account-balance/index.vue'], resolve),
        meta: {
          title: 'Saldos Contables',
          permission: "Saldos Contables"
        }
      },
      {
        path: '/reportes/estados-financieros',
        component: resolve => require(['../views/estados-financieros/index.vue'], resolve),
        meta: {
          title: 'Reporte de Estados Financieros Por Mes',
          permission: "Analytrix Ventas Ultimo Semestre"
        }
      },
      {
        path: '/reportes/detalle-de-ventas',
        component: resolve => require(['../views/sales-detail/index.vue'], resolve),
        meta: {
          title: 'Reporte de Ventas Analitrix',
          permission: "Reporte de Ventas Analitrix",
        }
      },
      {
        path: '/reportes/gestion-presupuesto',
        component: resolve => require(['../views/sales-budget/index.vue'], resolve),
        meta: {
          title: 'Gestión presupuesto',
          permission: 'Gestión presupuesto',
        }
      },
      {
        path: '/reportes/detalle-gestion-presupuesto',
        component: resolve => require(['../views/sales-budget-detail/index.vue'], resolve),
        meta: {
          title: 'Detalle gestión presupuesto',
          permission: 'Gestión presupuesto',
        }
      },
          {
              path: '/reportes/comisiones-venta-marca',
              component: resolve => require(['../views/report-commission-sale-brand/index.vue'], resolve),
              meta: {
                  title: 'Comisiones x Venta x Marca',
                  permission: "Comisiones x Venta x Marca"
              }
          },
          {
            path: '/reportes/gestion-presupuesto-clientes',
            component: resolve => require(['../views/sales_budget_by_contacts_warehouses/index.vue'], resolve),
            meta: {
                title: 'Gestión presupuesto',
                permission: 'Gestión presupuesto',
            }
        },
        {
            path: '/reportes/conciliacion-inventario',
            component: resolve => require(['../views/inventory-reconciliation/index.vue'], resolve),
            meta: {
                title: 'Conciliación Inventario',
                permission: 'Conciliacion Inventario',
            }
        },
        {
            path: '/reportes/reporte-comisiones-recaudo',
            component: resolve => require(['../views/Report-commisions-collection/index.vue'], resolve),
            meta: {
                title: 'Informe de Comisiones por Recaudo',
                permission: "Informe de Comisiones por Recaudo"
            }

        },
        {

            path: '/reportes/reporte-resultado-integral-eri',
            component: resolve => require(['../views/report-result-eri/index.vue'], resolve),
            meta: {
                title: 'Estado de resultado integral ERI',
                permission: "Estado de resultado integral ERI"

            }
        },

        {
            path: '/reportes/reporte-despachos',
            component: resolve => require(['../views/picking-report/index.vue'], resolve),
            meta: {
                title: 'Informe Despachos',
            }
        },
        {
            path: '/reportes/saldos-por-tercero',
            component: resolve => require(['../views/balance-for-contacts/index'], resolve),
            meta: {
                title: 'Informe De Saldos Por Tercero',
                permission: "Informe De Saldos Por Tercero"
            }
        },
        {
            path: '/reportes/reporte-pharex',
            component: resolve => require(['../views/report-pharex/index.vue'], resolve),
            meta: {
                title: 'Reporte Pharex',
                permission:"Reporte Pharex"
            }
        },
        {
          path: '/reportes/solicitud-garantias',
            component: resolve => require(['../views/guarantees/index.vue'], resolve),
            meta: {
                title: 'Gestión de garantías'
            }
        },
        {
            path: '/reportes/informe-inventario',
            component: resolve => require(['../views/inventory-report/index.vue'], resolve),
            meta: {
                title: 'Inventario valorizado',
                permission: "Inventario valorizado"
            }
        },
        {
            path: '/reportes/consignacion-cheques',
            component: resolve => require(['../views/check-consignment/index.vue'], resolve),
            meta: {
                title: 'Consignación De Cheques',
                permission: "Consignacion De Cheques"
            }
        },
        {
            path: '/reportes/reporte-maximos-minimos',
            component: resolve => require(['../views/report-max-min/index'], resolve),
            meta: {
                title: 'Informe Máximos y Mínimos',
                permission: "Informe Máximos y Mínimos"
            }
        },
        {
            path: '/reportes/informe-reposicion-v2',
            component: resolve => require(['../views/report-inventory-replacement-v2'], resolve),
            meta: {
                title: 'Informe de Reposición de Inventario V2',
                permission: "Informe de Reposicion de Inventario V2"
            }
        },
        {
          path: '/reportes/contact-balance',
            component: resolve => require(['../views/contact-balance/index.vue'], resolve),
            meta: {
                title: 'Balance por Tercero',
                permission: "Balance por Tercero"
            }
        },
        {
            path: '/reportes/reporte-usuarios-documentos',
            component: resolve => require(['../views/report-user-documents/index'], resolve),
            meta: {
                title: 'Movimientos de Usuarios / Documento',
                permission: "Movimientos de Usuarios"
            }
        },
        {
            path: '/reportes/reporte-operaciones-rango-fecha',
            component: resolve => require(['../views/report-date-range/index'], resolve),
            meta: {
                title: 'Informe Operaciones Rango Fecha',
                permission: "Informe Operaciones Rango Fecha"
            }
        },

        {
            path: '/reportes/reporte-traslados',
            component: resolve => require(['../views/report-transfers/index'], resolve),
            meta: {
                title: 'Informe de Traslados',
                permission: "Informe de Traslados"

            }
        },
        {
            path: '/reportes/reporte-relacion-documentos',
            component: resolve => require(['../views/report-sales-referrals/index'], resolve),
            meta: {
                title: "Informe de Relación de Documentos",
                permission: "Informe de Relación de Documentos",
            }
        },
        {
          path: '/reportes/reporte-documentos-pendientes-orden-despacho',
            component: resolve => require(['../views/report-document-pending-dispatch-order/index'], resolve),
            meta: {
                title: 'Documentos Pendientes Orden Despacho',
                permission: "Documentos Pendientes Orden Despacho"
            }
        },
    ]
  }
]



// WEBPACK FOOTER //
// ./src/reports-aggrid/router/index.js